import authService from "@/backend/services/auth";
import router from "@/router";
import store from "@/store/store";

export default {
  async executeStart({ commit, dispatch }, params = null) {
    return new Promise((resolve, reject) => {
      authService
        .start(params)
        .then((response) => {
          commit("setStart", response);
          commit("isStarting", false);
          // Pass in_page to executePing so redirect happens after isLoggedIn is confirmed
          const inPage = response?.in_page ?? null;
          dispatch("executePing", inPage);
          resolve(response);
        })
        .catch((error) => {
          // Even if start fails, set isStarting to true so the app can render
          commit("isStarting", true);
          console.error("Auth start error:", error);
          reject(error);
        });
    });

    // const data = await authService.start();
    // commit("isStarting", false);
    // commit("setStart", data);
    // await dispatch("executePing");
  },
  async executePing({ commit, dispatch }, inPage = null) {
    return new Promise((resolve, reject) => {
      authService
        .ping()
        .then((response) => {
          if (
            response &&
            response.login_token_valid &&
            response.login_token_valid == false
          ) {
            resolve(dispatch("logout"));
          } else {
            commit("setPing", response);
            store.dispatch("account/setLoggedIn", response);
            commit("isStarting", true);
            if (inPage) {
              dispatch("redirectAfterLoginSuccess", inPage);
            }
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  redirectAfterLoginSuccess(context, page) {
    const pageRouteNames = {
      cart: "my-shopping-cart",
      orders: "my-orders",
    };

    const routeName = pageRouteNames[page];
    if (routeName) {
      const route = router.resolve({ name: routeName });
      if (globalThis.location.pathname !== route.path) {
        router.push(route);
      }
    }
  },
  async redirectToLoginPage({ commit, rootGetters }, data) {
    setTimeout(async () => {
      let isStarting = rootGetters["auth/isStarting"];
      const isLoggedIn = rootGetters["account/isLoggedIn"];

      if (isLoggedIn === false) {
        let returnURL = data.returnUrl;

        if (
          !returnURL.includes("meine-bestellungen") &&
          !returnURL.includes("warenkorb") &&
          !returnURL.includes("bargeld/form")
        ) {
          returnURL = "/";
        }
        commit("setReturnUrl", globalThis.location.origin + returnURL);
        
        // Determine current page for in_page parameter
        let inPageParam = null;
        if (returnURL.includes("warenkorb")) {
          inPageParam = "cart";
        } else if (returnURL.includes("meine-bestellungen")) {
          inPageParam = "orders";
        }

        if (isStarting) {
          // Get the login url data from backend with in_page parameter
          const loginParams = inPageParam ? { in_page: inPageParam } : null;
          let loginData = await authService.getLoginData(loginParams);
          
          // Redirect to login page
          location.href = loginData.url;
        }
      }
    }, 2000);
  },
  async getLogoutCookie() {
    return await authService.getLogoutCookie();
  },
  async logoutComplete({ dispatch }) {
    const currentRoute = router.currentRoute;
    if (currentRoute.meta && currentRoute.meta.requiresAuth === true) {
      await dispatch("getLogoutCookie");
      window.location.reload();
    } else {
      // No login required
      await authService.deleteLoginCookie();
      await dispatch("getLogoutCookie");
    }
  },

  // @todo this is copied from the old pb and needs to be rewritten but I am not sure when this piece of code is executed
  // var logout = function ()
  // {
  //   //redirect to the logout page
  //   if (!_.isUndefined($rootScope.customBranding.logoutURL)
  //       && !_.isNull($rootScope.customBranding.logoutURL))
  //   {
  //     $window.location.href = $rootScope.customBranding.logoutURL;
  //   }
  //   else
  //   {
  //     $log.error('Logout Failed');
  //   }
  // };
};
